import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { CompanyAPI ,AuthAPI} from "./api/apiClient";

export default function RegisterCompany() {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    clientName: "",
    description: "",
    contactPerson: "",
    username: "",   // ✅ ADD HERE
    email: "",
    password: "",
    phoneNo: "",
    companyWebsite: ""
  });

  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    setError("");
    setSuccess("");

    try {
     // await CompanyAPI.registerCompany(form);

      //setSuccess("Company + SuperAdmin created successfully!");

      //setTimeout(() => navigate("/"), 1500);
     // setTimeout(() => navigate("/add-user"), 1500);
     await CompanyAPI.registerCompany(form);

// 🔥 LOGIN USING YOUR EXISTING AUTH API
const loginRes = await AuthAPI.login(
  form.email,     // because your backend uses email as username
  form.password
);

// 🔥 STORE TOKEN
//localStorage.setItem("token", loginRes.token);
if (!loginRes.token) {
  throw new Error("Login succeeded but token was not returned");
}

localStorage.setItem("token", loginRes.token);

// (optional)
setSuccess("Company created & logged in successfully!");

// 🔥 NAVIGATE
navigate("/add-user");

    } 
    /*catch (err: any) {
      setError(err.message || "Failed to register company");
    }*/
   catch (err: any) {
  let message = "Failed to register company";

  try {
    const parsed = JSON.parse(err.message);
    message = parsed.message || message;
  } catch {
    message = err.message || message;
  }

  setError(message);
}
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4">
      <div className="max-w-lg w-full bg-white rounded-2xl shadow-lg p-8">

        <h2 className="text-2xl font-semibold text-center mb-6">
          Register Company
        </h2>

        <form onSubmit={handleSubmit} className="space-y-4">

          <input name="clientName" placeholder="Client Name"
            value={form.clientName} onChange={handleChange}
            required className="w-full border rounded-lg px-3 py-2" />

          <input name="description" placeholder="Description"
            value={form.description} onChange={handleChange}
            className="w-full border rounded-lg px-3 py-2" />

          <input name="contactPerson" placeholder="Contact Person"
            value={form.contactPerson} onChange={handleChange}
            className="w-full border rounded-lg px-3 py-2" />

          <input
  name="username"
  placeholder="Super Admin Username"
  value={form.username}
  onChange={handleChange}
  required
  className="w-full border rounded-lg px-3 py-2"
/>

          <input name="email" placeholder="Email (Super Admin Login)"
            value={form.email} onChange={handleChange}
            required className="w-full border rounded-lg px-3 py-2" />

          <input name="password" type="password" placeholder="Password"
            value={form.password} onChange={handleChange}
            required className="w-full border rounded-lg px-3 py-2" />

          <input name="phoneNo" placeholder="Phone Number"
            value={form.phoneNo} onChange={handleChange}
            className="w-full border rounded-lg px-3 py-2" />

          <input name="companyWebsite" placeholder="Company Website"
            value={form.companyWebsite} onChange={handleChange}
            className="w-full border rounded-lg px-3 py-2" />

          {error && <div className="text-red-600 text-sm">{error}</div>}
          {success && <div className="text-green-600 text-sm">{success}</div>}

          <button className="w-full bg-green-600 text-white py-2 rounded-lg">
            Register Company
          </button>

          <button type="button"
            onClick={() => navigate("/")}
            className="text-sm text-gray-600 hover:underline w-full">
            Back to Login
          </button>

        </form>
      </div>
    </div>
  );
}